import { Link } from "react-router-dom";
import { Home, MessageCircle, ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/constants";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "Page Not Found · InvitationWala",
    description:
      "The page you were looking for doesn't exist. Browse our digital wedding invitations or message us on WhatsApp.",
    canonical: "https://www.invitationwala.online/404",
    noindex: true,
  });

  return (
    <main
      className="min-h-screen grid place-items-center p-6"
      style={{
        background:
          "radial-gradient(ellipse at 30% 20%, rgba(212,175,55,0.08) 0%, transparent 55%), radial-gradient(ellipse at 70% 80%, rgba(232,165,180,0.08) 0%, transparent 55%), #0a0a0a",
      }}
      data-testid="not-found-page"
    >
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-[var(--iw-gold)]" />
          <span className="overline text-[var(--iw-gold)]">404 · Not Found</span>
          <span className="w-8 h-px bg-[var(--iw-gold)]" />
        </div>
        <h1
          className="font-serif-display text-[var(--iw-ivory)] text-5xl md:text-7xl leading-[0.95]"
          style={{ fontFamily: "Cormorant Garamond, serif" }}
        >
          The page has{" "}
          <span className="italic gold-rose-gradient">eloped</span>.
        </h1>
        <p className="text-[var(--iw-muted)] mt-6 leading-relaxed max-w-md mx-auto">
          We couldn't find what you were looking for. But your perfect digital
          invitation is just one tap away.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="btn-gold" data-testid="not-found-home">
            <Home size={14} /> Back to Home
          </Link>
          <a
            href={`https://wa.me/${BRAND.whatsapp}?text=Hi%20InvitationWala%2C%20I%20landed%20on%20a%20broken%20link.`}
            target="_blank"
            rel="noreferrer"
            className="btn-ghost-gold"
            data-testid="not-found-whatsapp"
          >
            <MessageCircle size={14} /> WhatsApp Us
          </a>
        </div>
        <Link
          to="/careers"
          className="inline-flex items-center gap-2 mt-12 overline text-[var(--iw-faint)] hover:text-[var(--iw-gold)] transition-colors"
        >
          <ArrowLeft size={12} /> Explore careers instead
        </Link>
      </div>
    </main>
  );
}
